import * as React from "react";

const IconTextLinkArrowRightHover: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 9"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#298CF0" d="M10.28 5.03L6.53 8.78a.746.746 0 01-1.06 0 .75.75 0 010-1.06l2.47-2.47H.75a.75.75 0 110-1.5h7.19L5.47 1.28A.75.75 0 116.53.22l3.75 3.75a.75.75 0 010 1.06z"/></svg>;
};

export default React.memo(IconTextLinkArrowRightHover);
